<template>
  <div class="m-brought-by-employee">
    <b-modal
      id="referrals-brought-by-employee-modal"
      v-model="localActive"
      size="custom-size"
      centered
      hide-footer
      hide-header
      @show="onShowModal"
      @close="localActive = false"
    >
      <svg
        class="m-brought-by-employee-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-brought-by-employee-title">Приведен сотрудником</div>
      <!--      <c-input-->
      <!--        class="m-brought-by-employee-employees-names"-->
      <!--        type="select"-->
      <!--        :searchable="true"-->
      <!--        :clearable="true"-->
      <!--        label="ФИО сотрудника"-->
      <!--        placeholder="Выберите сотрудника"-->
      <!--        :items="employeesNamesLocalItems"-->
      <!--        v-model="employeeNameLocalValue"/>-->
      <c-input-old
        v-model="employeeNameLocalValue"
        class="m-brought-by-employee-employees-names"
        type="select"
        :searchable="true"
        :clearable="true"
        floating-label="ФИО сотрудника"
        :items="employeesNamesLocalItems"
      />
      <div class="m-brought-by-employee-buttons">
        <c-button class="m-brought-by-employee-buttons-close" label="Закрыть" @click="closeModal" />
        <c-button
          color="primary"
          class="m-brought-by-employee-buttons-save"
          label="Сохранить"
          @click="saveBroughtEmployee"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";
import InputOld from "@/components/controls/input-old";

export default {
  name: "referrals-brought-by-employee-modal",
  components: {
    "c-input-old": InputOld,
    "c-button": Button,
  },
  props: ["active", "currentBroughtEmployee"],
  data() {
    return {
      localActive: false,
      employeesNamesLocalItems: [],
      employeeNameLocalValue: null,
    };
  },

  watch: {
    localActive(value) {
      if (!value) {
        this.$emit("close");
        setTimeout(() => {
          this.employeeNameLocalValue = this.currentBroughtEmployee;
        }, 200);
      }
    },
    active(value) {
      this.localActive = value;
    },
    currentBroughtEmployee(value) {
      this.employeeNameLocalValue = value;
    },
  },

  methods: {
    closeModal() {
      this.localActive = false;
    },

    onShowModal() {
      this.$store.dispatch("personalEmployee/getWorkersList").then((res) => {
        this.postLocalItems = [];
        this.employeesNamesLocalItems = res.response.map((worker) => ({
          label: worker.name,
          value: worker.id,
          isUser: worker.is_user,
        }));
      });
    },

    saveBroughtEmployee() {
      const workerId = this.$route.params.id;
      this.$store
        .dispatch("personalEmployee/saveBroughtEmployeeInfo", {
          workerId,
          invitedById: this.employeeNameLocalValue === null ? 0 : this.employeeNameLocalValue.value,
        })
        .then(() => {
          this.closeModal();
          this.$emit("saveBroughtEmployee", this.employeeNameLocalValue);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.m-brought-by-employee {
  position: relative;

  &-close {
    cursor: pointer;
    position: absolute;
    top: 12px;
    right: 10px;
  }

  &-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;

    @media screen and (max-width: 700px) {
      font-size: 15px;
      line-height: 120%;
    }
  }

  &-employees-names {
    margin-top: 18px;

    ::v-deep .c-input-action_clear_active {
      margin-top: 0;
    }

    @media screen and (max-width: 700px) {
      margin-top: 20px;
    }
  }

  &-buttons {
    margin-top: 29px;
    display: flex;
    justify-content: flex-end;
    align-self: center;

    @media screen and (max-width: 700px) {
      width: calc(100% + 40px);
      max-width: calc(100% + 40px);
      margin: 42px 0 -28px -20px;
    }

    &-close {
      max-width: 120px;

      @media screen and (max-width: 700px) {
        max-width: 50%;
        width: 50%;
        border-radius: 0;
        border-left: none;
        border-bottom: none;
      }
    }

    &-save {
      margin-left: 10px;
      max-width: 125px;

      @media screen and (max-width: 700px) {
        max-width: 50%;
        margin-left: 0;
        width: 50%;
        border-radius: 0;
        border-left: none;
        border-bottom: none;
      }
    }
  }
}
</style>
